// ModalConcluirProducao.jsx
import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import { useAuth } from "../../Context/auth"; // Verifique o caminho

// --- Modal de Tamanho ---
// (Este modal edita/mostra quantidades POR VOLUME)
const TamanhoModal = ({ isVisible, onClose, tamanhosData, onSave, gradeNome, isReadOnly = false }) => {
    const [tamanhosEmEdicao, setTamanhosEmEdicao] = useState([]);

    useEffect(() => {
        // Clona os dados para edição
        setTamanhosEmEdicao(JSON.parse(JSON.stringify(Array.isArray(tamanhosData) ? tamanhosData : [])));
    }, [tamanhosData]);

    if (!isVisible) return null;

    const handleUpdateQtde = (idOuTamanho, newQtde) => {
        const qtde = Math.max(0, Number(newQtde.replace(/[^0-9]/g, '')));
        if (isNaN(qtde)) return;
        setTamanhosEmEdicao(prev => prev.map(item =>
            (item.id === idOuTamanho || item.tamanho === idOuTamanho) ? { ...item, quantidade: qtde } : item
        ));
    };

    const somatorio = tamanhosEmEdicao.reduce((sum, item) => sum + (Number(item.quantidade) || 0), 0);

    const handleSave = () => {
        // Salva as quantidades POR VOLUME configuradas
        onSave(tamanhosEmEdicao);
    };

    const modalStyle = {
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 1070 // z-index maior que o modal principal
    };
    const contentStyle = {
        backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '500px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
    };

    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <div className="modal-header p-0 pb-2 border-bottom">
                    {/* Alterado título para refletir que são quantidades por volume */}
                    <h5 className="modal-title">{isReadOnly ? "Visualizar" : "Quantidades por Volume"}: {gradeNome}</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body p-0 py-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="d-flex justify-content-between mb-3 fw-bold border-bottom pb-1">
                        <span>Tamanho</span>
                        {/* Alterado label */}
                        <span>Quantidade por Volume</span>
                    </div>
                    {tamanhosEmEdicao.map((item, index) => (
                        <div key={item.id || item.tamanho || index} className="d-flex justify-content-between align-items-center mb-2 p-2 border-bottom">
                            <span className="fw-bold">{item.tamanho}</span>
                            <input
                                type="number"
                                className="form-control form-control-sm text-center"
                                value={item.quantidade}
                                onChange={(e) => handleUpdateQtde(item.id || item.tamanho, e.target.value)}
                                min="0"
                                style={{ width: '80px' }}
                                disabled={isReadOnly}
                            />
                        </div>
                    ))}
                    {tamanhosEmEdicao.length === 0 && <p className='text-muted text-center'>Nenhum tamanho encontrado.</p>}
                </div>
                <div className="modal-footer p-0 pt-3 border-top d-flex justify-content-between">
                     {/* Alterado label */}
                    <span className="me-auto fw-bold">TOTAL POR VOLUME: {somatorio}</span>
                    <button type="button" className="btn btn-secondary" onClick={onClose}>{isReadOnly ? "Fechar" : "Cancelar"}</button>
                    {!isReadOnly && (
                        <button type="button" className="btn btn-success" onClick={handleSave}>Confirmar</button>
                    )}
                </div>
            </div>
        </div>
    );
};


// --- Componente Principal do Modal de Conclusão ---
function ModalConcluirProducao({ isVisible, onClose, producaoId, numeroOp, itensProduzir, onConclusaoSucesso }) {
    const { currentUser } = useAuth();
    const [dataConclusao, setDataConclusao] = useState(new Date().toISOString().split('T')[0]);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [quantidadeSimples, setQuantidadeSimples] = useState(0);
    const [tamanhosConfig, setTamanhosConfig] = useState([]); // Quantidades POR VOLUME
    // ==================== NOVO ESTADO ====================
    const [volumesConcluir, setVolumesConcluir] = useState(1); // Estado para volumes (grade)
    // ==================== FIM NOVO ESTADO ====================
    const [isGradeModalVisible, setIsGradeModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState('');

    // Filtra apenas itens que AINDA NÃO estão 100% concluídos
    const itensDisponiveis = useMemo(() => {
        return (itensProduzir || []).filter(item => item.status !== 'Concluído');
    }, [itensProduzir]);

    // Item da produção selecionado no <select> (Corrigido com Number())
    const selectedItem = useMemo(() => {
        return itensProduzir.find(item => item.id === Number(selectedItemId));
    }, [selectedItemId, itensProduzir]);

    // Verifica se o item selecionado tem grade (Corrigido)
    const isGrade = useMemo(() => {
        return selectedItem?.tamanhos_json && Array.isArray(selectedItem.tamanhos_json) && selectedItem.tamanhos_json.length > 0;
    }, [selectedItem]);

    // Calcula quantidades restantes (simples e por tamanho na grade - TOTAIS)
    const calcularQtdeRestanteSimples = (item) => {
        if (!item) return 0;
        const total = Number(item.quantidade_total_unidades) || 0;
        const concluido = Number(item.quantidade_concluida) || 0;
        return Math.max(0, total - concluido);
    };

    const calcularQtdeRestanteGrade = (item) => { // Retorna array [{ tamanho: 'P', quantidade: X }] com restantes TOTAIS
        if (!item || !Array.isArray(item.tamanhos_json)) return [];
        const planejadosMap = new Map();
        item.tamanhos_json.forEach(t => planejadosMap.set(t.tamanho, Number(t.quantidade) || 0)); // Qtdes por volume
        const concluidosMap = new Map();
        (Array.isArray(item.tamanhos_concluidos_json) ? item.tamanhos_concluidos_json : [])
            .forEach(t => concluidosMap.set(t.tamanho, Number(t.quantidade) || 0)); // Qtdes totais concluídas
        const volumesPlanejados = Number(item.quantidade_volumes) || 1;
        const restantes = [];
        for (const [tamanho, qtdePlanejadaVol] of planejadosMap.entries()) {
            const qtdePlanejadaTotal = qtdePlanejadaVol * volumesPlanejados;
            const qtdeConcluida = concluidosMap.get(tamanho) || 0;
            const qtdeRestante = Math.max(0, qtdePlanejadaTotal - qtdeConcluida);
            restantes.push({ tamanho: tamanho, quantidade: qtdeRestante }); // Quantidade RESTANTE TOTAL
        }
        restantes.sort((a, b) => a.tamanho.localeCompare(b.tamanho));
        return restantes;
     };

    // Calcula volumes restantes (para limitar input de volumes - OPCIONAL)
    const volumesRestantes = useMemo(() => {
        if (!selectedItem || !isGrade) return 1; // Default para não quebrar
        const totalPlanejado = Number(selectedItem.quantidade_total_unidades) || 0;
        const totalConcluido = Number(selectedItem.quantidade_concluida) || 0;
        const unidadesPorVolume = selectedItem.tamanhos_json.reduce((sum, t) => sum + (Number(t.quantidade) || 0), 0);
        if (unidadesPorVolume <= 0) return 0;
        const unidadesRestantes = Math.max(0, totalPlanejado - totalConcluido);
        return Math.floor(unidadesRestantes / unidadesPorVolume);
    }, [selectedItem, isGrade]);


    // Reseta/Preenche campos ao mudar item
    useEffect(() => {
        setQuantidadeSimples(0);
        setTamanhosConfig([]);
        // Não reseta volumes aqui
        if (selectedItem) {
            if (isGrade) {
                // Preenche config de tamanhos com quantidades POR VOLUME (padrão da ficha ou grade)
                const qtdsPorVolumePadrao = selectedItem.tamanhos_json.map(t => ({
                    tamanho: t.tamanho,
                    quantidade: Number(t.quantidade) || 0
                })).sort((a, b) => a.tamanho.localeCompare(b.tamanho));
                setTamanhosConfig(qtdsPorVolumePadrao);
                
                // Define os volumes com o total restante (calculado pelo useMemo 'volumesRestantes')
                // Garante que seja no mínimo 0
                setVolumesConcluir(Math.max(0, volumesRestantes));

            } else {
                 // Preenche quantidade simples com o restante
                 setQuantidadeSimples(calcularQtdeRestanteSimples(selectedItem));
            }
        } else {
            // Se nenhum item selecionado, reseta para 1
            setVolumesConcluir(1);
        }
    }, [selectedItem, isGrade, volumesRestantes]); // <-- ADICIONA volumesRestantes

    // ==================== NOVO CÓDIGO ABAIXO ====================
    // Efeito para auto-selecionar se houver apenas um item disponível
    useEffect(() => {
        // Verifica se a lista de itens disponíveis foi calculada e tem exatamente 1 item
        if (itensDisponiveis && itensDisponiveis.length === 1) {
            // Define automaticamente o ID do item. 
            // Garante que seja string para o <select> funcionar corretamente.
            setSelectedItemId(String(itensDisponiveis[0].id));
        }
    }, [itensDisponiveis]); // Depende da lista de itens disponíveis
    // ==================== FIM DO NOVO CÓDIGO ====================


    // Hook para chamadas API (sem alterações)
    const apiCall = async (url, method = 'POST', data = null) => {
        if (!currentUser) throw new Error("Usuário não autenticado.");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const config = {
            method,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch(`${API_URL}${url}`, config);
        if (!response.ok) {
             const errorData = await response.json().catch(() => ({}));
             throw new Error(errorData.error || `Falha na requisição (${response.status})`);
        }
         if (response.status === 204) return null;
        return response.json();
     };

    // Quantidade restante simples (para validação)
    const qtdeRestanteSimples = useMemo(() => calcularQtdeRestanteSimples(selectedItem), [selectedItem]);

    // Calcula o total de unidades a concluir COM BASE NOS VOLUMES
    const totalUnidadesGradeConcluir = useMemo(() => {
        if (!isGrade || !Array.isArray(tamanhosConfig)) return 0;
        const unidadesPorVolume = tamanhosConfig.reduce((sum, t) => sum + (Number(t.quantidade) || 0), 0);
        return unidadesPorVolume * (Number(volumesConcluir) || 0);
    }, [isGrade, tamanhosConfig, volumesConcluir]);


    // --- Handlers ---
    const handleSaveTamanhos = (tamanhosEditados) => {
        // Salva as quantidades POR VOLUME editadas
        setTamanhosConfig(tamanhosEditados);
        setIsGradeModalVisible(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensagem('');

        if (!selectedItem) {
            Swal.fire('Atenção', 'Selecione um item da produção válido.', 'warning');
            return;
        }

        let dataToSend;
        const qtdeJaConcluida = Number(selectedItem.quantidade_concluida) || 0;
        const qtdeTotalPlanejada = Number(selectedItem.quantidade_total_unidades) || 0;
        const qtdeTotalRestante = Math.max(0, qtdeTotalPlanejada - qtdeJaConcluida);

        if (isGrade) {
            const qtdeConcluirHoje = totalUnidadesGradeConcluir; // Usa o total calculado

            if (qtdeConcluirHoje <= 0) {
                Swal.fire('Atenção', 'A quantidade total a concluir (volumes * grade) deve ser maior que zero.', 'warning');
                return;
            }
            // Valida contra o TOTAL restante
            if (qtdeConcluirHoje > qtdeTotalRestante) {
                 Swal.fire('Atenção', `A quantidade total a concluir (${qtdeConcluirHoje}) excede o total restante (${qtdeTotalRestante}). Ajuste os volumes ou as quantidades por volume.`, 'warning');
                return;
            }

            // Cria o JSON para o backend com as quantidades TOTAIS por tamanho (qtde_por_vol * volumes)
            const tamanhosJsonParaBackend = tamanhosConfig.map(t => ({
                tamanho: t.tamanho,
                quantidade: (Number(t.quantidade) || 0) * (Number(volumesConcluir) || 0)
            })).filter(t => t.quantidade > 0); // Envia apenas tamanhos com quantidade > 0

            // Verifica se o array resultante não está vazio (caso volumes seja 0 ou todas qtdes por vol sejam 0)
            if (tamanhosJsonParaBackend.length === 0 && qtdeConcluirHoje > 0) {
                 Swal.fire('Erro interno', 'Falha ao calcular as quantidades por tamanho para envio.', 'error');
                 return;
            }


            dataToSend = {
                producaoItemId: Number(selectedItem.id),
                dataConclusao: dataConclusao,
                tamanhosJson: tamanhosJsonParaBackend // Envia as quantidades TOTAIS concluídas HOJE
            };

        } else {
            // Item simples
            const qtdeConcluirHoje = Number(quantidadeSimples);
            if (qtdeConcluirHoje <= 0) {
                 Swal.fire('Atenção', 'A quantidade a concluir deve ser maior que zero.', 'warning');
                 return;
            }
            // Valida contra o restante simples
            if (qtdeConcluirHoje > qtdeRestanteSimples) {
                 Swal.fire('Atenção', `A quantidade (${qtdeConcluirHoje}) excede o restante (${qtdeRestanteSimples}).`, 'warning');
                return;
            }
            dataToSend = {
                producaoItemId: Number(selectedItem.id),
                dataConclusao: dataConclusao,
                quantidade: qtdeConcluirHoje
            };
        }

        setLoading(true);
        try {
            await apiCall(`/api/producao/${producaoId}/concluir`, 'POST', dataToSend);
            Swal.fire('Sucesso!', 'Conclusão registrada e estoque atualizado!', 'success');
            onConclusaoSucesso(); // Fecha modal e recarrega dados
        } catch (error) {
            console.error("Erro ao concluir item:", error);
            setMensagem(error.message);
            Swal.fire('Erro', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    // --- Renderização ---
    if (!isVisible) return null;
    const modalStyle = { /* ... estilos ... */
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 1050
    };
    const contentStyle = { /* ... estilos ... */
        backgroundColor: 'white', padding: '25px', borderRadius: '8px', width: '90%', maxWidth: '700px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
     };

    return (
        <>
            {/* Modal de Grade (para editar qtde POR VOLUME) */}
            {isGradeModalVisible && (
                 <TamanhoModal
                    isVisible={isGradeModalVisible}
                    onClose={() => setIsGradeModalVisible(false)}
                    tamanhosData={tamanhosConfig} // Passa as qtdes POR VOLUME atuais
                    onSave={handleSaveTamanhos} // Salva as qtdes POR VOLUME editadas
                    gradeNome={selectedItem?.grade_descricao || ''}
                    isReadOnly={false}
                 />
            )}

            {/* Modal Principal de Conclusão */}
            <div style={modalStyle}>
                <div style={contentStyle}>
                    <div className="modal-header border-bottom pb-2 mb-3">
                        <h4 className="modal-title">Concluir Item da OP <span className="text-primary">#{numeroOp}</span></h4>
                        <button type="button" className="btn-close" onClick={onClose} disabled={loading}></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body p-0">
                             {/* ==================== CORREÇÃO AQUI ==================== */}
                             {mensagem && <div className="alert alert-danger">{mensagem}</div>}
                             {/* ==================== FIM DA CORREÇÃO ==================== */}
                            {itensDisponiveis.length === 0 && ( <div className="alert alert-warning">Todos os itens desta produção já foram concluídos.</div> )}

                            <div className="row g-3">
                                {/* Data Conclusão */}
                                <div className="col-md-3">
                                    <label className="form-label">Data da Conclusão</label>
                                    <input type="date" className="form-control" value={dataConclusao} onChange={(e) => setDataConclusao(e.target.value)} required />
                                </div>

                                {/* Select Item */}
                                <div className="col-md-9">
                                    <label className="form-label">Item a Concluir</label>
                                    <select
                                        className="form-select"
                                        value={selectedItemId}
                                        onChange={e => setSelectedItemId(e.target.value)}
                                        required
                                        disabled={itensDisponiveis.length === 0}
                                    >
                                        <option value="">Selecione um item...</option>
                                        {itensDisponiveis.map(item => {
                                            // Calcula o restante para exibir na opção
                                            // CORREÇÃO: Usa 'item' do map para calcular isGrade localmente
                                            const itemIsGrade = item.tamanhos_json && Array.isArray(item.tamanhos_json) && item.tamanhos_json.length > 0;
                                            const restante = itemIsGrade
                                                ? calcularQtdeRestanteGrade(item).reduce((s,t)=>s+t.quantidade,0)
                                                : calcularQtdeRestanteSimples(item);
                                            return (
                                                <option key={item.id} value={item.id}>
                                                    {item.produto_codigo} - {item.produto_descricao} (Cor: {item.cor || 'N/A'})
                                                    {' - Restante: '} {restante}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                {/* Renderização Condicional Grade */}
                                {selectedItem && isGrade && (
                                    <>
                                        {/* Input Qtde. Volumes */}
                                        <div className="col-md-3">
                                            <label className="form-label">Qtde. Volumes</label>
                                            <input
                                            type="number"
                                            className="form-control"
                                            value={volumesConcluir}
                                            onChange={e => setVolumesConcluir(Math.max(0, Number(e.target.value) || 0))}
                                            min="0"
                                            step="1"
                                        />
                                             {/* <div className="form-text">Restante: {volumesRestantes} volumes</div> */}
                                        </div>

                                        {/* Botão Configurar Grade */}
                                        <div className="col-md-9 d-flex align-items-end">
                                            <div className='w-100'>
                                                <label className="form-label">Quantidades por Volume</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-info w-100"
                                                    onClick={() => setIsGradeModalVisible(true)}
                                                    disabled={!tamanhosConfig || tamanhosConfig.length === 0}
                                                >
                                                    <i className="fa-solid fa-box-open me-2"></i>
                                                    Configurar Quantidades por Volume
                                                </button>
                                            </div>
                                        </div>

                                        {/* Display Total Unidades */}
                                        <div className='col-12 mt-2'>
                                            <p className="mb-0 text-muted">
                                                Total a concluir: {' '}
                                                <strong className='text-dark'>
                                                    {totalUnidadesGradeConcluir} unidades
                                                </strong>
                                                {' '} ({volumesConcluir} {Number(volumesConcluir) === 1 ? 'volume' : 'volumes'})
                                            </p>
                                        </div>
                                    </>
                                )}

                                {/* Renderiza campo Qtde. Simples se NÃO for grade */}
                                {selectedItem && !isGrade && (
                                     <div className="col-md-4">
                                        <label className="form-label">Quantidade a Concluir</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={quantidadeSimples}
                                            onChange={e => setQuantidadeSimples(Math.max(0, Number(e.target.value)))}
                                            max={qtdeRestanteSimples}
                                            min="0"
                                            step="1"
                                        />
                                         <div className="form-text">
                                            Restante: {qtdeRestanteSimples} unidades
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="modal-footer border-top pt-3 mt-4">
                            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={loading}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-success" disabled={loading || !selectedItemId || itensDisponiveis.length === 0}>
                                {loading ? 'Confirmando...' : 'Confirmar Conclusão'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ModalConcluirProducao;

